var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.64645 3.64645C1.84171 3.45118 2.15829 3.45118 2.35355 3.64645L6 7.29289L9.64645 3.64645C9.84171 3.45118 10.1583 3.45118 10.3536 3.64645C10.5488 3.84171 10.5488 4.15829 10.3536 4.35355L6.35355 8.35355C6.15829 8.54882 5.84171 8.54882 5.64645 8.35355L1.64645 4.35355C1.45118 4.15829 1.45118 3.84171 1.64645 3.64645Z",
    fill: "#19A1B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownSm);
export default __webpack_public_path__ + "static/media/down-sm.06d7fd1182c0c2abf3cc388ae4a2bf9e.svg";
export { ForwardRef as ReactComponent };